import { render } from "./studioNews.vue?vue&type=template&id=30f9fee3&scoped=true"
import script from "./studioNews.vue?vue&type=script&lang=js"
export * from "./studioNews.vue?vue&type=script&lang=js"

import "./studioNews.vue?vue&type=style&index=0&id=30f9fee3&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f9fee3"]])

export default __exports__